import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { Input } from 'reactstrap'
import './student-list.scss';
import { ImageConstants, AccessRights } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source';
import SchoolUserApi from '../../../apis/student'
import SchoolApi from '../../../apis/school';
import SessionCache from '../../routes/session-cache';
import CWConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import AddStudentComponent from '../../class/add-student/add-student';
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import Dropdown from '../../common/dropdown-v2/dropdown';
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import Utils from '../../../utility/common-utilities';

const REJECT_REASONS = [
    { title: "NOT_SCHOOL_STUDENT", value: "Not School Student" },
    { title: "ALREADY_EXISTS", value: "Already Exists" }
]
class StudentList extends Component {
    state = {
        classDetails: this.props.classDetails,
        studentList: [],
        isValidForm: false,
        selectedBulkAction: null,
        selectedStudents: [],
        removedStudents: [],
        selectedBoard: '',
        selectedClass: '',
        selectedSectionsId: []
    }

    currentPage = 1
    limit = 10

    accessRights = SessionCache.getAllowedModule()

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }

    componentDidMount() {
        this.getClassAndBoard()

    }

    onClickAddStudent(item, mode) {
        this.setState({ openAddStudent: true, selectedUser: item, mode })
    }

    closeAddStudentModal = () => {
        this.setState({ openAddStudent: false, })
    }

    onClickInvite(item, type) {
        this.setState({ emailSendConfirmModal: true, deleteMessage: "Are you sure want send invitation", inviteUser: item, inviteType: type })
    }

    onClickBulkInvite(type) {
        this.setState({ bulkInviteConfirmModal: true, bulkInviteMessage: "Are you sure want send invitation to selected users", inviteType: type })
    }

    onClassSectionUpdate() {
        this.setState({ showClassSectionUpdate: true })
    }

    showAcceptBulkConfirmModal = (item) => {
        let message = `Are you sure, you want to approve selected students from this school?`
        this.setState({ selectedUser: item, showAcceptBulkConfirmModal: true, acceptMessage: message })
    }

    showRejectBulkConfirmModal = (item) => {
        let message = `Are you sure, you want to reject selected students from this school?`
        this.setState({ selectedUser: item, showRejectBulkConfirmModal: true, rejectMessage: message })
    }

    showAcceptConfirmModal = (item) => {
        let message = `Are you sure, you want to approve ${item.name} from this school?`
        this.setState({ selectedUser: item, showAcceptConfirmModal: true, acceptMessage: message })
    }

    showRejectConfirmModal = (item) => {
        let message = `Are you sure, you want to reject ${item.name} from this school?`
        this.setState({ selectedUser: item, showRejectConfirmModal: true, rejectMessage: message })
    }

    showStudentDetails = (item) => {
        this.setState({ selectedStudent: item, showStudentDetails: true })
    }

    hideConfirmModal = () => {
        this.setState({ emailSendConfirmModal: false, showConfirmModal: false, bulkInviteConfirmModal: false, showAcceptConfirmModal: false, showRejectConfirmModal: false, showStudentDetails: false, showAcceptBulkConfirmModal: false, showRejectBulkConfirmModal: false, showClassSectionUpdate: false })
        if (this.tooltip) {
            this.tooltip.tooltipRef = null
            this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
    }

    onSelectBulkAction = (action) => {
        const payload = {}
        if (action === "email" || action === "whatsapp" || action === "sms") payload.status = { value: "ONBOARDED", title: "Invite Sent" }
        if (action === "approve" || action === "reject") payload.schoolApprovalStatus = { value: "TO_BE_APPROVED", title: "To be Approved" }
        if (action === "delete") {
            payload.forBulkDelete = true
        }
        this.props.onRefreshList(payload, () => {
            this.setState({
                selectedBulkAction: action,
                allStudentSelected: true
            })
        })
    }

    onSelect = (option, key) => {
        this.setState({ [key]: option }, _ => {
            this.validatePayload()
        })
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value }, _ => {
            this.validatePayload()
        })
    }

    validatePayload = _ => {
        this.setState({
            isValidForm: false
        })
        if (!this.state.rejectReason) return false
        if (!this.state.rejectDetails) return false
        this.setState({
            isValidForm: true
        })
        return true
    }

    removeUser = () => {
        let payload = {}
        if (this.state.bulkDelete) {
            payload.ignoreUserId = this.state.deleteItem
            payload.bulkDelete = true
        } else {
            payload.userId = this.state.deleteItem
        }
        SchoolUserApi.deleteSchoolUser(payload)
            .then(response => {
                if (this.state.bulkDelete) {
                    this.showToaster("info", `${this.state.meta?.count - this.state.deleteItem?.length} students deleted`)
                }
                this.props.onRefreshList({})
                this.hideConfirmModal()
                this.hideBulkActions()
            }).catch(err => {
                console.log(err)
            })
    }

    sendInvite = () => {
        let payload = {
            userId: this.state.inviteUser?._id,
            type: this.state.inviteType
        }
        SchoolApi.sendStudentInvite(payload)
            .then(response => {
                this.props.onRefreshList({})
                this.hideConfirmModal()
            }).catch(err => {
                console.log(err)
            })
    }

    sendBulkInvite = () => {
        let payload = {
            students: this.state.removedStudents,
            type: this.state.inviteType
        }

        if (this.state.selectedBoard) {
            payload.board = this.state.selectedBoard
        } else if (this.state.boards.length === 1) {
            payload.board = this.state.boards[0].value
        }

        if (this.state.selectedClass) {
            payload.class = this.state.selectedClass
        }

        if (this.state.selectedSectionsId && this.state.selectedSectionsId.length) {
            payload.sectionId = this.state.selectedSectionsId
        }



        SchoolUserApi.sendStudentBulkInvite(payload)
            .then(response => {
                this.showToaster("info", `Message sent to ${this.state.meta?.count} students`)
                this.hideConfirmModal()
                this.props.onRefreshList({})
                this.setState({
                    selectedBulkAction: ""
                })
            }).catch(err => {
                console.log(err)
            })
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }

    assignClassSection = _ => {
        const { selectedClass, section, sectionId } = this.state
        if (!selectedClass || !section || !sectionId) {
            this.setState({
                showError: true,
                errorMessage: "Please select class & section"
            })
            return
        }
        this.setState({ isSubmit: true })
        const { selectedStudents } = this.state;
        if (!selectedStudents || !selectedStudents.length) return
        const payload = {
            students: selectedStudents,
            class: selectedClass,
            section,
            sectionId
        }
        SchoolUserApi.bulkAssignClassSection(payload).then(res => {
            this.setState({ isSubmit: false })
            this.props.onRefreshList({})
            this.hideConfirmModal()
        }).catch(e => {
            this.setState({ isSubmit: false })
        })
    }

    onRejectSubmit = _ => {
        const { selectedBulkAction } = this.state
        this.setState({ showError: true })
        let isValid = this.validatePayload()
        if (!isValid) {
            this.setState({
                errorMessage: "Reject Reason and Message are required fields"
            })
            return
        }
        this.setState({ isSubmit: true })
        if (selectedBulkAction === "approve" || selectedBulkAction === "reject") {
            this.userSchoolApprovalBulkUpdate(false)
        } else {
            this.userSchoolApprovalStatusUpdate(false)
        }
    }

    userSchoolApprovalStatusUpdate = approved => {
        const payload = {
            schoolUserId: this.state.selectedUser._id,
            userId: this.state.selectedUser.userId,
            schoolApprovalStatus: {
                type: approved ? "APPROVED" : "REJECTED",
                typeText: approved ? "Approved" : "Rejetced"
            }
        }
        if (!approved) {
            payload.rejectDetails = this.state.rejectDetails
            payload.rejectReason = this.state.rejectReason
        }
        SchoolUserApi.userSchoolApprovalStatusUpdate(payload).then(res => {
            this.setState({ isSubmit: false })
            this.props.onRefreshList({})
            this.hideConfirmModal()
        }).catch(e => {
            this.setState({ isSubmit: false })
        })
    }

    userSchoolApprovalBulkUpdate = approved => {
        const { removedStudents } = this.state;
        const payload = {
            students: removedStudents,
            schoolApprovalStatus: {
                type: approved ? "APPROVED" : "REJECTED",
                typeText: approved ? "Approved" : "Rejetced"
            }
        }
        if (!approved) {
            payload.rejectDetails = this.state.rejectDetails
            payload.rejectReason = this.state.rejectReason
        }
        SchoolUserApi.userSchoolApprovalBulkUpdate(payload).then(res => {
            this.showToaster("info", `${this.state.meta?.count - removedStudents?.length} students ${approved ? "approved" : "rejected"}`)
            this.setState({ isSubmit: false })
            this.props.onRefreshList({})
            this.hideConfirmModal()
            this.hideBulkActions()
        }).catch(e => {
            this.setState({ isSubmit: false })
        })
    }

    renderContact(contactDetails = [], type) {
        return (
            <>
                {
                    contactDetails.length ? contactDetails.map(item => (
                        <div>
                            {/* <div className='phone-number-title text-left'>{item.type}</div> */}
                            {
                                type === "phone" && item.mobileNumber ? <div>{item.countryCode} {item.mobileNumber}{item?.secondaryMobileNumber? ` / ${item.secondaryMobileNumber}` : ''}</div> : ""
                            }
                            {
                                type === "email" && item.email ? <div>{item.email}</div> : ""
                            }
                        </div>
                    )) : ""
                }
            </>
        )

    }

    onChangePreviousyearMarkHandler = (value) => {
        this.setState({ previousYearMark: value })
    }

    onSaveEditMark = (index) => {
        let studentList = this.state.studentList || []
        let student = studentList[index]
        student.previousYearMark = { mark: this.state.previousYearMark }
        studentList[index] = student
        this.setState({ studentList, showPreviosMarkIndex: "", previousYearMark: "" })


        let payload = {
            _id: student?._id,
            previousYearMark: +this.state.previousYearMark
        }

        SchoolUserApi.updateSchoolUser(payload).then(response => {
        }).catch(err => {
        })
    }

    onEditPreviousYearMark = (index) => {
        this.setState({ showPreviosMarkIndex: index })
    }
    onClosePreviousYearMark = () => {
        this.setState({ showPreviosMarkIndex: "" })
    }

    onSaveStudent = () => {
        this.props.onRefreshList({})
        this.setState({ openAddStudent: false, showBulkImportModal: false })
    }

    showConfirmModal = (item) => {
        let deleteItem = []
        let bulkDelete = false
        if (item === "bulk") {
            deleteItem = this.state.removedStudents
            bulkDelete = true
        } else if (item) {
            deleteItem = [item._id]
        }

        this.setState({ showConfirmModal: true, deleteMessage: `Are you sure want to delete ${item ? item?.name : "selected students"} from School ?`, deleteItem, bulkDelete })
    }

    onClickAllCheckBox = () => {
        this.setState({ allStudentSelected: !this.state.allStudentSelected }, _ => {
            if (!this.state.allStudentSelected) {
                this.hideBulkActions()
            }
        })
    }

    onToggleSelectedStudent = id => {
        const { removedStudents } = this.state
        const idx = removedStudents.findIndex(ss => ss === id)
        if (idx > -1) {
            removedStudents.splice(idx, 1)
        } else {
            removedStudents.push(id)
        }
        this.setState({
            removedStudents
        })
    }

    onSelectClass = (option) => {
        if (!option) {
            this.setState({ class: "", sections: [] });
            return;
        }
        this.selectedClass = this.state.classes.filter(item => item.value == option)[0]

        this.setState({ selectedClass: option.value }, () => {
            this.getSections()
        })
    }

    onSelectSection = (option) => {
        if (!option) {
            this.setState({ section: "" });
            return;
        }
        this.setState({ section: option?.title, sectionId: option?.value })
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.currentPage = selectedPage
        this.props.onPageSelected(selectedPage, startIndex)
    }

    renderRejectPopup() {
        const { rejectReason, rejectDetails, isValidForm, isSubmit, showError } = this.state
        return (
            <Modal className="cw-custom-modal reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"lg"}>
                <ModalBody >
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="reject-modal-body">
                        <div className="title">Reject Reason </div>
                        <div className='row'>
                            <div className='col'>
                                <Dropdown
                                    text='value'
                                    placeholder='Select Reject Reason'
                                    options={REJECT_REASONS}
                                    invalid={showError && !rejectReason}
                                    onSelect={option =>
                                        this.onSelect(option, 'rejectReason')
                                    }
                                    value={rejectReason}
                                    style={{ background: '#F6F7F5' }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <textarea className={`message-input ${showError && !rejectDetails ? 'invalid' : ''}`} placeholder='Enter any other details'
                                    value={rejectDetails}
                                    onChange={(e) => this.onChangeHandler(e, 'rejectDetails')} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col text-center mt-4'>
                                {this.state.errorMessage ? <div className="text-danger"><strong>{this.state.errorMessage} </strong></div> : ""}
                                <button className={`cw-button-primary ${(!isValidForm || isSubmit) ? "disable-button" : ""}`} onClick={_ => this.onRejectSubmit()}>
                                    REJECT
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderStudentDetails() {
        const { selectedStudent } = this.state
        return (
            <Modal className="cw-custom-modal reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"lg"}>
                <ModalBody >
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    {selectedStudent &&
                        <div className="student-details px-5">
                            <div className='title text-left'>{selectedStudent.name}</div>
                            <table className="table">
                                <tr>
                                    <td className='col-title'>CLASS</td>
                                    <td className='col-value'>{selectedStudent.class}</td>
                                </tr>
                                <tr>
                                    <td className='col-title'>SECTION</td>
                                    <td className='col-value'>{selectedStudent.section}</td>
                                </tr>
                                <tr>
                                    <td className='col-title'>ROLL NO.</td>
                                    <td className='col-value'>{selectedStudent.rollNumber}</td>
                                </tr>
                                <tr>
                                    <td className='col-title'>EMAIL</td>
                                    <td className='col-value'>{this.renderContact(selectedStudent.contactDetails, "email")}</td>
                                </tr>
                                <tr>
                                    <td className='col-title'>REGISTER PHONE NO.</td>
                                    <td className='col-value'>{this.renderContact(selectedStudent.contactDetails, "phone")}</td>
                                </tr>
                                <tr>
                                    <td className='col-title'>CONNECT CODE</td>
                                    <td className='col-value'>{selectedStudent.verificationCode}</td>
                                </tr>
                                <tr>
                                    <td className='col-title'>STATUS</td>
                                    <td className='col-value'>{selectedStudent.schoolApprovalStatus?.type === "TO_BE_APPROVED" ? selectedStudent.schoolApprovalStatus.typeText : selectedStudent?.status?.typeText}</td>
                                </tr>
                            </table>
                        </div>
                    }
                </ModalBody>
            </Modal>
        )
    }

    renderClassSectionModal() {
        const { selectedClass, section, sectionId, errorMessage, isValidForm, isSubmit } = this.state
        return (
            <Modal className="cw-custom-modal class-section reject-modal" isOpen={true} toggle={this.hideConfirmModal} size={"md"}>
                <ModalBody >
                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideConfirmModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className='title'>Assign selected students to new class & section</div>
                    <div className='row mb-3'>
                        <div className='col-3 label pr-0'>
                            <label className='cw-input-label'>Class</label>
                        </div>
                        <div className='col-9 pl-1'>
                            {this.state.classes?.length > 0 &&
                                <Dropdown
                                    placeholder='Select'
                                    options={this.state.classes}
                                    onSelect={(option) => this.onSelectClass(option)}
                                    text={"title"}
                                    value={this.state.class}
                                    style={{ backgroundColor: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.class}
                                />
                            }
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className='col-3 label pr-0'>
                            <label className='cw-input-label'>Section</label>
                        </div>
                        <div className='col-9 pl-1'>
                            {this.state.sections?.length > 0 &&
                                <Dropdown
                                    placeholder='Select'
                                    options={this.state.sections}
                                    onSelect={(option) => this.onSelectSection(option)}
                                    text={"title"}
                                    value={this.state.section}
                                    style={{ backgroundColor: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.section}
                                />
                            }
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col text-center mt-4'>
                            {errorMessage ? <div className="text-danger"><strong>{this.state.errorMessage} </strong></div> : ""}
                            <button className={`cw-button-primary ${(!selectedClass || !section || !sectionId || isSubmit) ? "disable-button" : ""}`} onClick={_ => this.assignClassSection()}>
                                ASSIGN
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    changePreviousYearMark = (mark, index) => {
        return (
            <div className="cw-card d-inline-block previous-year-mark">
                <div className="close-icon-wrapper">
                    <img className="mark-close-icon cursor-pointer" onClick={this.onClosePreviousYearMark} src={getImageSource(ImageConstants.CROSS)} />
                </div>
                <div className='mt-2'>
                    <input className={`cw-input`} placeholder='Enter Marks'
                        value={this.state.mark}
                        onChange={(e) => this.onChangePreviousyearMarkHandler(e.target.value, index)} />
                </div>

                <div className='text-center mt-2'>
                    <button className="cw-button-primary text-center" onClick={() => this.onSaveEditMark(index)}>
                        Save
                    </button>
                </div>
            </div>
        )
    }

    // getSectionList = _ => {
    //     console.log(this.addStudentRef)
    //     this.addStudentRef.getSections({})
    // }

    renderAddStudent() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.closeAddStudentModal} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.closeAddStudentModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>{this.state.mode == "CREATE" ? "ADD A STUDENT" : "EDIT STUDENT"}</span>
                    </div>
                    <div className="px-4">
                        <AddStudentComponent ref={el => this.addStudentRef = el} showSetupSection={this.props.showSetupSection} mode={this.state.mode} selectedClass={this.state.classDetails} selectedUser={this.state.selectedUser} size={'lg'} onSave={this.onSaveStudent} onClose={this.closeAddStudentModal} />
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    getClassAndBoard(payload = {}) {

        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [], classNames = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                let board = this.state.board
                if (boards.length) {
                    board = boards[0].value
                }


                classNames = classes.map(c => c.value)

                // this.getSections({board, class : classNames})

                this.setState({ board, class: classNames, classes: classes, boards: boards })
            }).catch(err => {
            })
    }


    getSections(payload = {}) {
        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.board

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = response.response
                let arr = []
                for (let i = 0; i < sections.length; i++) {
                    let section = sections[i]
                    arr.push({
                        title: section.section,
                        value: section._id,
                    })
                }
                let classDetails = {
                    class: this.state.class,
                    board: this.state.board
                }
                this.setState({ sections: arr },)
            }).catch(err => {
                this.setState({ sections: [], section: "" })
            })
    }

    showBulkActions = _ => {
        this.setState({
            showBulkActions: true
        })
    }

    getStudent(payload, filter, cb) {
        if (!payload) payload = filter || {}

        payload.page = filter.page || 1
        payload.limit = this.limit

        this.currentPage = payload.page

        console.log(payload)

        this.setState({
            isLoading: true,
            selectedBoard: payload.board,
            selectedClass: payload.class,
            selectedSectionsId: payload.sectionId
        })
        SchoolUserApi.getSchoolUsers(payload)
            .then(response => {
                this.setState({
                    studentList: response.response,
                    meta: response.meta || {},
                    isLoading: false,
                    showList: false
                }, () => {
                    cb()
                    this.setState({ showList: true })
                })
            }).catch(err => {
                this.setState({ studentList: [], isLoading: false })
            })
    }

    hideBulkActions = _ => {
        const payload = {}
        this.props.onRefreshList(payload, () => {
            this.setState({
                showBulkActions: false,
                selectedBulkAction: null,
                selectedStudents: [],
                allStudentSelected: false,
                removedStudents: []
            })
        })
    }


    onClickKey = (item) => {
        console.log(item)
        this.setState({ showPasswordUpdate: true, selectedItem: item, passcode: '', passcodeSetSuccessMessage: '' })
    }

    closeModal = () => {
        this.setState({ showPasswordUpdate: false, selectedItem: null, password: "", errMessage: "", passcodeSetSuccessMessage: '' })
    }


    onChangePasscodeHandler = (event, key) => {
        this.setState({ [key]: event.target.value, errMessage: '', passcodeSetSuccessMessage: '' })
    }

    onReload = () => {
        this.setState({ spin: true, errMessage: '', passcodeSetSuccessMessage: '' })
        setTimeout(() => {
            let passcode = Utils.getRandomString()
            this.setState({ passcode, spin: false })
        }, 500)
    }

    updatePasscode = () => {

        let payload = {
            userId: this.state.selectedItem?.userId,
            passcode: this.state.passcode
        }

        if (!this.state.passcode || this.state.passcode?.length < 4) {
            this.setState({ errMessage: "Passcode must be at least 4 characters" })
            return
        }

        SchoolApi.updatePasscode(payload).then(response => {
            console.log(response)
            //   this.closeModal()

            if (response.status === 200) {
                this.setState({ passcodeSetSuccessMessage: `Passcode Updated Successfully.` })
            }

        }).catch(err => {
            console.log("Error", err)
        })
    }


    renderPasswordUpdateModal() {
        return (
            <Modal className="custom-modal" isOpen={true} toggle={this.closeModal} size={'md'}>
                <ModalHeader toggle={this.closeModal} className="custom-z-index">
                    <span className='update-passcode-text'>Update Passcode for <strong>{this.state.selectedItem.name.toUpperCase()}</strong> </span>
                </ModalHeader>
                <ModalBody >
                    <div>
                        <FontAwesomeIcon className="float-right mr-4 mt-4 reload-icon" icon={faSyncAlt} onClick={this.onReload} spin={this.state.spin} color={"green"} />
                        <div className='row bw-spaces-input'>
                            <div className='col'>
                                <label className='cw-input-label'>New Passcode <span className='star'>*</span></label>
                                <input className={`cw-input ${this.state.isSubmit && !this.state.passcode ? "invalid" : ""}`} placeholder='Enter new password'
                                    value={this.state.passcode}
                                    onChange={(e) => this.onChangePasscodeHandler(e, 'passcode')} />
                            </div>
                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.state.errMessage ? <span className="text-danger pr-4"><b> {this.state.errMessage}</b></span> : ""
                    }
                    {
                        this.state.passcodeSetSuccessMessage ? <span className='text-success pr-5'>{this.state.passcodeSetSuccessMessage}</span> : <></>
                    }
                    {
                        this.state.passcodeSetSuccessMessage ? <button className={`cw-button`} onClick={this.closeModal}>Close</button> : <button className={`cw-button`} onClick={this.updatePasscode}>Update</button>
                    }

                </ModalFooter>
            </Modal>
        )
    }



    render() {
        const { showBulkActions, selectedBulkAction, studentList, removedStudents, allStudentSelected } = this.state
        return (
            <div className="student-list">
                <div className='students-count'>
                    {selectedBulkAction &&
                        <span>{this.state.meta?.count - removedStudents.length} students selected</span>
                    }
                </div>
                <div className='student-status-count'>
                    {this.state.meta?.onBoardedCount !== 0 &&
                        <span className=''>
                            <img className="vector-icon ml-2 mr-1 mb-2" src={getImageSource(ImageConstants.ONBOARDED_NEW)} />

                            <span className='count-bold mr-1'>{this.state.meta?.onBoardedCount}</span>
                            <span className='text-bold'>onboarded</span>
                        </span>
                    }
                    {this.state.meta?.inviteSentCount !== 0 &&
                        <span className='ml-3'>
                            <img className="vector-icon mr-2" src={getImageSource(ImageConstants.INVITE_SENT_NEW)} />
                            <span className='count-bold mr-1'>{this.state.meta?.inviteSentCount}</span>
                            <span className='text-bold'>Invite Sent</span>
                        </span>
                    }
                </div>
                <div id="table-scoll" className="table-responsive mt-1">
                    <table className="table cw-table">
                        <thead>
                            <tr>
                                <th className='th-left-radius'>
                                    {selectedBulkAction &&
                                        <div
                                            className={`${allStudentSelected && removedStudents.length <= 0
                                                ? 'active-checkbox'
                                                : 'inactive-checkbox'
                                                } d-inline-block`}
                                            onClick={this.onClickAllCheckBox}
                                        >
                                            <img
                                                className='d-inline-block img'
                                                src={getImageSource(
                                                    allStudentSelected && removedStudents.length <= 0
                                                        ? ImageConstants.RECT_TICK
                                                        : ImageConstants.RECT
                                                )}
                                            />
                                        </div>
                                    }
                                </th>

                                <th>Name</th>
                                <th>Class</th>
                                <th >Roll No</th>
                                <th>Connect Code</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th>Passcode</th>
                                {/* <th className="text-center">Previous Year Marks</th> */}
                                

                                <th className='th-right-radius list-actions-header'>
                                    <div className='text-right'>
                                        <button className={`bulk-action-btn`} onClick={_ => this.showBulkActions()}>
                                            Bulk Actions
                                        </button>
                                    </div>
                                    {showBulkActions &&
                                        <div className='bulk-actions'>
                                            <div className='text-right pr-2' onClick={this.hideBulkActions}>
                                                <img className="vector-icon cursor-pointer" src={getImageSource(ImageConstants.CROSS)} />
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "email" ? "active-action" : selectedBulkAction && selectedBulkAction !== "email" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "email" ? this.onClickBulkInvite("email") : this.onSelectBulkAction("email") }}>
                                                <img className="vector-icon" src={getImageSource(selectedBulkAction !== "email" ? ImageConstants.ENVELOPE : ImageConstants.ENVELOPE_WHITE)} /> <span className='action-name'>Send Email Reminder</span>
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "whatsapp" ? "active-action" : selectedBulkAction && selectedBulkAction !== "whatsapp" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "whatsapp" ? this.onClickBulkInvite("whatsapp") : this.onSelectBulkAction("whatsapp") }}>
                                                <img className="vector-icon" src={getImageSource(selectedBulkAction !== "whatsapp" ? ImageConstants.WHATSAPP : ImageConstants.WHATSAPP_WHITE)} /> <span className='action-name'>Send Whatsapp Reminder</span>
                                            </div>
                                            {/* <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "sms" ? "active-action" :  selectedBulkAction && selectedBulkAction !== "sms" ? "hide": ""} ${!studentList.length ? "disabled": ""}`} onClick={() => { if(studentList.length > 0) selectedBulkAction === "sms" ? this.onClickBulkInvite("sms"): this.onSelectBulkAction("sms") }}>
                                                <img className="vector-icon" src={getImageSource(selectedBulkAction !== "sms" ? ImageConstants.MESSAGE : ImageConstants.MESSAGE_WHITE)} /> <span className='action-name'>Send SMS Reminder</span>
                                            </div> */}
                                            {!selectedBulkAction &&
                                                <div className='divider'></div>
                                            }
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "approve" ? "active-action" : selectedBulkAction && selectedBulkAction !== "approve" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "approve" ? this.showAcceptBulkConfirmModal() : this.onSelectBulkAction("approve") }}>
                                                <img className="vector-icon" src={getImageSource(selectedBulkAction !== "approve" ? ImageConstants.TICK_BLACK : ImageConstants.TICK_BLACK)} /> <span className='action-name'>Approve Students</span>
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer ${selectedBulkAction === "reject" ? "active-action" : selectedBulkAction && selectedBulkAction !== "reject" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "reject" ? this.showRejectBulkConfirmModal() : this.onSelectBulkAction("reject") }}>
                                                <img className="vector-icon" src={getImageSource(selectedBulkAction !== "reject" ? ImageConstants.CROSS_BLACK : ImageConstants.CROSS_BLACK)} /> <span className='action-name'>Reject Students</span>
                                            </div>
                                            <div className={`mx-4 py-2 cursor-pointer delete-icon ${selectedBulkAction === "delete" ? "active-action" : selectedBulkAction && selectedBulkAction !== "delete" ? "hide" : ""} ${!studentList.length ? "disabled" : ""}`} onClick={() => { if (studentList.length > 0) selectedBulkAction === "delete" ? this.showConfirmModal("bulk") : this.onSelectBulkAction("delete") }}>
                                                <img className="vector-icon" src={getImageSource(selectedBulkAction !== "delete" ? ImageConstants.DELETE_RED : ImageConstants.DELETE_WHITE)} /> <span className='action-name'>Delete</span>
                                            </div>
                                        </div>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {
                                this.state.studentList && this.state.studentList.length ? this.state.studentList.map((item, index) => (

                                    <tr className={`mt-4 ${item.schoolApprovalStatus?.type === "TO_BE_APPROVED" ? "to-be-approved" : ""}`} key={item._id} onMouseEnter={ReactTooltip.rebuild}>
                                        <td>
                                            {selectedBulkAction && <>
                                                {removedStudents.findIndex(rs => rs === item._id) < 0 ?
                                                    <div className='text-left active-checkbox d-inline-block' onClick={_ => this.onToggleSelectedStudent(item._id)}>
                                                        <img className="d-inline-block img" src={getImageSource(ImageConstants.RECT_TICK)} />
                                                    </div>
                                                    : <div className='text-left inactive-checkbox d-inline-block' onClick={_ => this.onToggleSelectedStudent(item._id)}>
                                                        <img className="d-inline-block img" src={getImageSource(ImageConstants.RECT)} />
                                                    </div>
                                                }
                                            </>
                                            }
                                        </td>
                                        <td className="">


                                            <div className="name-text cursor-pointer" onClick={_ => this.onClickAddStudent(item, "EDIT")}>

                                                <img className="vector-icon mr-2 mb-1" src={getImageSource(item.status?.type == "ONBOARDED" ? ImageConstants.ONBOARDED_NEW : ImageConstants.INVITE_SENT_NEW)} />
                                                {item.name}
                                            </div>
                                            {item?.isSubscribed && <div className=''><span className='premium-text'>{"Premium"}</span></div>}
                                            {
                                                this.accessRights[AccessRights.ADD_STUDENT] && item.schoolApprovalStatus?.type === "TO_BE_APPROVED" &&
                                                <div>
                                                    <span onClick={_ => this.showAcceptConfirmModal(item)} className='cursor-pointer'>
                                                        <img
                                                            data-tip={"Accept Student profile"}
                                                            className='approve-icn'
                                                            src={getImageSource(ImageConstants.GREEN_TICK_V1)}
                                                        />
                                                    </span>
                                                    <span onClick={_ => this.showRejectConfirmModal(item)} className='cursor-pointer'>
                                                        <img
                                                            data-tip={"Reject Student profile"}
                                                            className='approve-icn'
                                                            src={getImageSource(ImageConstants.RED_REMOVE)}
                                                        />
                                                    </span>
                                                </div>
                                            }
                                        </td>
                                        <td>{item.class} - {item.section}</td>
                                        <td>{this.user?.schoolInfo?.schoolCode === 'SCX-1450' ? item?.contactDetails.length && item?.contactDetails[0]?.secondaryMobileNumber? item?.contactDetails[0].secondaryMobileNumber : item.rollNumber :item.rollNumber}</td>
                                        <td>{item.verificationCode}</td>
                                        <td className=''>{this.renderContact(item?.contactDetails, 'phone')}</td>
                                        <td className=''>{this.renderContact(item?.contactDetails, 'email')}</td>
                                        <td>{<span className={`${item.schoolApprovalStatus?.type !== "TO_BE_APPROVED" && item.status?.type == 'ONBOARDED' ? "onboard-text" : "invite-sent-text"}`}>{item.schoolApprovalStatus?.type === "TO_BE_APPROVED" ? item.schoolApprovalStatus.typeText : item?.status?.typeText}</span>}</td>
                                        {/* <td className="text-center">{
                                            item.previousYearMark?.mark ? item.previousYearMark?.mark :
                                                <div className="mark-td">
                                                    <div className="add-previous-mark" onClick={() => { this.onEditPreviousYearMark(index) }}> ADD</div>
                                                    {this.state.showPreviosMarkIndex === index ? this.changePreviousYearMark(0, index) : ""}
                                                </div>
                                        }
                                        </td> */}
                                        
                                        <td>
                                            <div className='text-center'>{item.status?.type == 'ONBOARDED' ?
                                                <FontAwesomeIcon color="green" className="cursor-pointer mr-2" icon={faKey} onClick={() => this.onClickKey(item)} data-tip={'Reset Passcode'} /> : ''}
                                            </div>
                                        </td>

                                        <td className='list-actions'>
                                            {item.schoolApprovalStatus?.type !== "TO_BE_APPROVED" &&
                                                <div className='pr-2'>
                                                    {
                                                        item.status && item.status?.type == 'INVITE_SENT' && this.accessRights[AccessRights.INVITE_STUDENT] ? <div>
                                                            <img className="email-icn mt-2 cursor-pointer" onClick={() => this.onClickInvite(item, "email")} src={getImageSource(ImageConstants.ENVELOPE)} data-tip="Invite Student Via Email" />
                                                        </div> : ""
                                                    }
                                                    {
                                                        item.status && item.status?.type == 'ONBOARDED' && this.accessRights[AccessRights.INVITE_STUDENT] ? <div>
                                                            <img className="email-icn mt-2 cursor-pointer" onClick={() => this.onClickInvite(item, "whatsapp")} src={getImageSource(ImageConstants.WHATSAPP)} data-tip="Invite Student Via Whatsapp" />
                                                        </div> : ""
                                                    }
                                                    {/* {
                                                    item.status && item.status?.type == 'INVITE_SENT' && this.accessRights[AccessRights.INVITE_STUDENT] ? <div>
                                                        <img className="email-icn mt-2 cursor-pointer" onClick={() => this.onClickInvite(item, "sms")} src={getImageSource(ImageConstants.MESSAGE)} data-tip="Invite Student Via SMS" />
                                                    </div> : ""
                                                } */}
                                                </div>
                                            }
                                            <div className='pr-2'>
                                                {
                                                    this.accessRights[AccessRights.EDIT_STUDENT] ?
                                                        <div onClick={() => { this.onClickAddStudent(item, "EDIT") }} data-tip="Edit User">
                                                            <img className="vector-icon mt-2 cursor-pointer" src={getImageSource(ImageConstants.EDIT)} />
                                                        </div> : ""
                                                }
                                                {
                                                    this.accessRights[AccessRights.DELETE_STUDENT] ?
                                                        <div onClick={() => { this.showConfirmModal(item) }} data-tip="Delete Student">
                                                            <img className="vector-icon mt-2 cursor-pointer" src={getImageSource(ImageConstants.DELETE_RED)} />
                                                        </div> : ""
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                    : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                            }
                        </tbody>
                    </table>
                </div >
                <div className='card-footer'>
                    {
                        this.state.meta?.totalPages ?
                            <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                    }
                </div>
                {this.state.openAddStudent && this.renderAddStudent()}
                {this.state.showConfirmModal && <CWConfirm modal={this.state.showConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.removeUser.bind(this)} />}
                {this.state.emailSendConfirmModal && <CWConfirm modal={this.state.emailSendConfirmModal} close={this.hideConfirmModal} message={this.state.deleteMessage} onOk={this.sendInvite.bind(this)} />}
                {this.state.bulkInviteConfirmModal && <CWConfirm modal={this.state.bulkInviteConfirmModal} close={this.hideConfirmModal} message={this.state.bulkInviteMessage} onOk={this.sendBulkInvite.bind(this)} />}
                {this.state.showAcceptConfirmModal && <CWConfirm modal={this.state.showAcceptConfirmModal} close={this.hideConfirmModal} message={this.state.acceptMessage} onOk={_ => this.userSchoolApprovalStatusUpdate(true)} />}
                {this.state.showAcceptBulkConfirmModal && <CWConfirm modal={this.state.showAcceptBulkConfirmModal} close={this.hideConfirmModal} message={this.state.acceptMessage} onOk={_ => this.userSchoolApprovalBulkUpdate(true)} />}
                {(this.state.showRejectConfirmModal || this.state.showRejectBulkConfirmModal) && this.renderRejectPopup()}
                {this.state.showStudentDetails && this.renderStudentDetails()}
                {this.state.showClassSectionUpdate && this.renderClassSectionModal()}
                {this.state.showPasswordUpdate ? this.renderPasswordUpdateModal() : ""}
                {this.state.showToaster ? (
                    <div className='custom-toaster-modal'>
                        <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" />
                    </div>
                ) : (
                    ''
                )}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        )
    }
}

export default StudentList;